import * as React from 'react';
import { rem } from 'polished';
import { __, __r } from 'react-i18n';
import styled from 'styled-components';
import { Button } from '../General/Button';
import { Loader } from '../../Defaults/Loader';

const Wrapper = styled.div<{ isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
`;

const UpperWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: -3px;
`;

const ContentWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  background: white;
  padding-top: ${rem(20)};
  padding-bottom: ${rem(20)};
  border-top: 1px solid #cccccc;
  flex-direction: row;

  ${({ theme }) => theme.mediab.l925`
      flex-direction: column;
      gap: ${rem(20)};
  `}
`;

const SliderWrapper = styled.div`
  width: 60%;
  ${({ theme }) => theme.mediab.l925`
      width: 100%;
      margin-left: ${rem(10)};
      margin-right: ${rem(10)};
  `}
`;

const RightContent = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: ${({ isOpen }) => (isOpen ? 'column' : 'row')};
  justify-content: center;
  align-items: center;
  gap: ${({ isOpen }) => (isOpen ? rem(20) : rem(40))};
  margin-left: ${rem(50)};

  ${({ theme }) => theme.mediab.l925`
      flex-direction: row;
      gap: ${rem(40)};
  `}
`;

const CancelText = styled.div`
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`;

const CompareButton = styled(Button)`
  min-height: ${rem(30)};
`;

const ArrowImg = styled.img`
  z-index: 2;
  cursor: pointer;
`;

interface Props {
  products: any[];
  onReset: () => void;
  isFetching: boolean;
  sliderComponent: any;
}

export function CompareFixedBottom({
  products,
  onReset,
  isFetching,
  sliderComponent
}: Props) {
  const [isOpen, setIsOpen] = React.useState(true);

  const toogleIsOpen = () => {
    if (isOpen) setIsOpen(false);
    else setIsOpen(true);
  };

  return (
    <Wrapper isOpen={isOpen} className="CompareFixedBottom">
      <UpperWrapper>
        {isOpen ? (
          <ArrowImg
            src="/images/static-compare-arrow-down.png"
            onClick={toogleIsOpen}
          />
        ) : (
          <ArrowImg
            src="/images/static-compare-arrow-up.png"
            onClick={toogleIsOpen}
          />
        )}
      </UpperWrapper>
      <Loader loading={isFetching}>
        <ContentWrapper>
          {isOpen ? (
            <SliderWrapper>
              {sliderComponent}
            </SliderWrapper>
          ) : (
            <></>
          )}
          <RightContent isOpen={isOpen}>
            <CancelText onClick={onReset}>{__('Vymazať všetko')}</CancelText>
            <a href={__r('routes:porovnanie', '/porovnanie')}>
              <CompareButton>
                {__('Porovnať')} ({products?.length})
              </CompareButton>
            </a>
          </RightContent>
        </ContentWrapper>
      </Loader>
    </Wrapper>
  );
}
